import React, { useEffect, useRef, useState } from 'react'
import { Button, Checkbox, Flex, Form, InputRef, Modal, notification } from 'antd'
import { AntdForm } from '@/components/AntdForm'
import { useImpersonateUserMutation } from '@/features/auth/auth.api.ts'
import { handleApiError } from '@/utils/api.tsx'
import { AntdFormRules } from '@/components/AntdForm/rules.tsx'

type FormValues = {
  username: string
}

export const ImpersonateUserModal: React.FC = () => {
  const inputRef = useRef<InputRef>(null)
  const [open, setOpen] = useState(false)
  const [needValidate, setNeedValidate] = useState(true)
  const [impersonateUser, { isLoading }] = useImpersonateUserMutation()
  const [form] = Form.useForm()

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        inputRef.current?.focus()
      }, 300)
    }
  }, [open])

  const showModal = () => {
    setOpen(true)
  }

  const onFinish = async (data: FormValues) => {
    const result = await impersonateUser({
      envName: import.meta.env.VITE_FINANCE_PORTAL_ENV,
      username: data.username,
    })
    if ('data' in result) {
      notification.success({ title: `Impersonate as ${data.username} successfully` })
      form.resetFields()
      setOpen(false)
      location.reload()
    } else {
      handleApiError(result.error, 'Impersonation failed')
    }
  }

  const handleCancel = () => {
    form.resetFields()
    setNeedValidate(true)
    setOpen(false)
  }

  return (
    <>
      <Button onClick={showModal}>Impersonate User</Button>
      <Modal
        open={open}
        title="Impersonate User"
        destroyOnHidden
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          layout="vertical"
          scrollToFirstError
          form={form}
          onFinish={onFinish}
        >
          <AntdForm.Input
            allowClear
            ref={inputRef}
            fieldProps={{
              name: 'username',
              rules: [AntdFormRules.required],
              validateDebounce: 1000,
            }}
          />
          <Checkbox checked={needValidate} onChange={e => setNeedValidate(e.target.checked)}>
            Validate username
          </Checkbox>
          <Flex gap="small" justify="flex-end">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>Save</Button>
          </Flex>
        </Form>
      </Modal>
    </>
  )
}